import { apiHelper } from '@/utils/requestHelpers';

export default {
  uploadStaffSchedule(data) {
    return apiHelper.post('/restapi/v1/admin/omo/upload/schedule', data);
  },
  uploadAllLocationSchedule(data) {
    return apiHelper.post('/restapi/v1/admin/omo/upload/all-schedules', data);
  },
  getStaffScheduleRecord(params) {
    return apiHelper.get('/restapi/v1/admin/omo/scheduleRecord', { params });
  },
  getStaffScheduleDetail(params) {
    return apiHelper.get('/restapi/v1/admin/omo/schedule', { params });
  },
  deleteStaffSchedule(data) {
    return apiHelper({
      url: '/restapi/v1/admin/omo/schedule',
      method: 'delete',
      data
    });
  },
  getOfflineAutoReply() {
    return apiHelper.get('/restapi/v1/admin/omo/offlineAutoReply');
  },
  createOfflineAutoReply(data) {
    return apiHelper({
      url: '/restapi/v1/admin/omo/offlineAutoReply',
      method: 'post',
      data
    });
  },
  updateOfflineAutoReply(data) {
    return apiHelper({
      url: '/restapi/v1/admin/omo/offlineAutoReply',
      method: 'put',
      data
    });
  },
  deleteOfflineAutoReply(data) {
    return apiHelper({
      url: `/restapi/v1/admin/omo/offlineAutoReply?locationCode=${data}`,
      method: 'delete'
    });
  }
};
